/* projects/shared/components/family-header/family-header.component.scss */
family-header {
  display: grid;
  width: 100%;
  height: 32px;
  background-color: black;
  color: #ffffff;
}
family-header .family-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 30px;
}
@media screen and (max-width: 767px) {
  family-header .family-header {
    margin: 0px 10px;
  }
}
family-header .family-header .left-side {
  display: flex;
  align-items: center;
  height: 100%;
}
family-header .family-header .logo-container {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0px 10px;
  border-right: 1px solid var(--color-grey);
}
family-header .family-header .header-logo {
  max-width: 45px;
  height: auto;
}
family-header .family-header .header-logo:hover {
  cursor: pointer;
}
family-header .family-header .application-name {
  font-weight: var(--font-weight-bold);
  font-size: var(--font-s);
  padding: 0px 10px;
}
@media screen and (max-width: 767px) {
  family-header .family-header .application-name {
    display: none;
  }
}
family-header .family-header .right-side {
  display: flex;
  align-items: center;
  height: 100%;
}
family-header .family-header .header-link {
  display: flex;
  align-items: center;
  padding: 0px 10px;
  height: 100%;
}
family-header .family-header .header-link:last-child {
  border-left: 1px solid var(--color-grey);
}
family-header .family-header .header-link > .button:hover {
  cursor: pointer;
}
/*# sourceMappingURL=family-header.component-TN6QGMNJ.css.map */
